import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { AdminService } from 'app/auth/service/admin.service';
import{ ChartDataSets } from 'chart.js';

import { Color, Label } from 'ng2-charts';

@Component({
  selector: 'app-lineChart',
  templateUrl: './lineChart.component.html',
  styleUrls: ['./lineChart.component.scss']
})
export class LineChartComponent implements OnInit, OnChanges {
  @Input()dadosGrafico : Array <any> =[];
  changeLog: string[] = [];
  constructor(){
  }

  ngOnChanges(changes: SimpleChanges) {
   /* const log: string[] = [];
    for (const propName in changes) {
      const changedProp = changes[propName];
      const to = JSON.stringify(changedProp.currentValue);
      if (changedProp.isFirstChange()) {
        log.push(`Initial value of ${propName} set to ${to}`);
      } else {
        const from = JSON.stringify(changedProp.previousValue);
        log.push(`${propName} changed from ${from} to ${to}`);
      }
    }
    this.changeLog.push(log.join(', '));
    */
   this.customizeChartLine();
  
  }

  ngOnInit() {
    this.dadosGrafico 
  
    this.customizeChartLine()
  }

  public lineChartLegend = false;
  public lineChartType = 'line';
 
  public lineChartData: ChartDataSets[] = [
    { 
      data: [],
      lineTension:0,
      fill: false,
    }
  ];

  public lineChartLabels: Label[] =[];
   public lineChartOptions: any = {
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            stepSize: 1,
          },
          gridLines: {},
        },
      ],
    },
    }
  
    
   
  
  public lineChartColors: Color[] = [
    {
      borderColor: '#86BC25',
      backgroundColor: '#87bc253b',
      pointBorderWidth:4,
      pointHitRadius:10,
    },
  ];


 public customizeChartLine(){  
  this.lineChartData[0].data = [];
  this.lineChartLabels = [];
   for (let item of this.dadosGrafico) {
     if(item.length == 0){
       this.lineChartData[0].data.push(0)
       this.lineChartLabels.push("Sem dados de visualização")
     }
     else {
      this.lineChartData[0].data.push(item?.quantity)
       this.lineChartLabels.push(item?.label)
     }
     
  }
}
}


  

